import createAPI from "../axios";

const trainingAgreementSkillsTraining = {
    trainingAgreement: {
        initCombo: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/initCombo', 'post', config),
        userList: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/userList', 'post', config),
        save: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/save', 'post', config),
        findCourseListByMajorId: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/findCourseListByMajorId', 'post', config),
        queryList: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/queryList', 'post', config),
        saveRec: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/saveRec', 'post', config),
        deletefile: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/deletefile', 'post', config),
        queryRscList: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/queryRscList', 'post', config),
        queryPxkc: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/queryPxkc', 'post', config),
        del: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/del', 'post', config),
        submit: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/submit', 'post', config),
        findPyfaByMajorId: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/findPyfaByMajorId', 'post', config),
        findCourseListByPyfaId: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/findCourseListByPyfaId', 'post', config),
        updateAuditState: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/updateAuditState', 'post', config),
        noticeTeacher: config => createAPI('/trainingAgreementSkillsTraining/trainingAgreement/noticeTeacher', 'post', config),
    }
}
export default trainingAgreementSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/trainingAgreementSkillsTraining.js